export default [
  {
    path: '/recruitment',
    name: 'recruitment',
    component: () => import('@/views/recruitment/index'),
    meta: { title: 'KOL招募' }
  },
  {
    path: '/recruitment/entrance',
    name: 'entrance',
    component: () => import('@/views/recruitment/entrance'),
    meta: { title: 'KOL招募' }
  },
  {
    path: '/recruitment/application',
    name: 'application',
    component: () => import('@/views/recruitment/application'),
    meta: { title: 'KOL招募' }
  },
  {
    path: '/recruitment/member',
    name: 'member',
    component: () => import('@/views/recruitment/member'),
    meta: { title: '成员' }
  },
  {
    path: '/recruitment/memberInfo',
    name: 'memberInfo',
    component: () => import('@/views/recruitment/memberInfo'),
    meta: { title: '成员信息' }
  },
  {
    path: '/recruitment/order',
    name: 'order',
    component: () => import('@/views/recruitment/order'),
    meta: { title: '订单记录', keepAlive: true }
  },
  {
    path: '/recruitment/orderInfo',
    name: 'orderInfo',
    component: () => import('@/views/recruitment/orderInfo'),
    meta: { title: '订单详情' }
  },
  {
    path: '/recruitment/dividends',
    name: 'dividends',
    component: () => import('@/views/recruitment/dividends'),
    meta: { title: '分红' }
  },
  {
    path: '/recruitment/statements',
    name: 'statements',
    component: () => import('@/views/recruitment/statements'),
    meta: { title: '财务报表' }
  },
  {
    path: '/recruitment/channel',
    name: 'channel',
    component: () => import('@/views/recruitment/channel'),
    meta: { title: '渠道生成' }
  },
  {
    path: '/recruitment/channelInfo',
    name: 'channelInfo',
    component: () => import('@/views/recruitment/channelInfo'),
    meta: { title: '渠道详情' }
  },
  {
    path: '/recruitment/calculationRules',
    name: 'calculationRules',
    component: () => import('@/views/recruitment/calculationRules'),
    meta: { title: '计算规则' }
  },
  {
    path: '/recruitment/vipRule',
    name: 'vipRule',
    component: () => import('@/views/recruitment/vipRule'),
    meta: { title: 'VIP专享' }
  },
  {
    path: '/recruitment/bill',
    name: 'bill',
    component: () => import('@/views/recruitment/bill'),
    meta: { title: '账变明细' }
  },
  {
    path: '/recruitment/rebateRecord',
    name: 'rebateRecord',
    component: () => import('@/views/recruitment/rebateRecord'),
    meta: { title: '返水记录' }
  },
  {
    path: '/recruitment/rebateInfo',
    name: 'rebateInfo',
    component: () => import('@/views/recruitment/rebateInfo'),
    meta: { title: '返水详情' }
  },
]


// WEBPACK FOOTER //
// ./src/router/config/Recruitment.js